import { Link } from 'react-router-dom';
import type { MediaItem } from '@/mocks/movies';
import RatingBadge from './RatingBadge';

interface MediaCardProps {
  item: MediaItem;
}

export default function MediaCard({ item }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block rounded-lg bg-background-50 transition-transform duration-300 hover:-translate-y-1"
      data-product-shop
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden rounded-lg border border-background-200 bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title}海报`}
          title={`${item.title} 粉色水蜜桃影视`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent" />
        <div className="absolute left-2.5 top-2.5 rounded-full bg-background-50/90 px-2.5 py-0.5 text-xs font-medium text-foreground-800">
          {item.typeLabel}
        </div>
        <div className="absolute right-2.5 top-2.5">
          <RatingBadge rating={item.rating} level={item.scoreLevel} />
        </div>
        <div className="absolute inset-x-0 bottom-0 p-3">
          <p className="line-clamp-2 text-xs leading-relaxed text-background-100 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            {item.summary}
          </p>
        </div>
      </div>
      <div className="pt-2.5">
        <h3 className="line-clamp-1 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-600">
          {item.region} · {item.year} · {item.genres.slice(0, 2).join(' / ')}
        </p>
      </div>
    </Link>
  );
}